import { toast } from '@/hooks/use-toast';

interface ToastOptions {
  successMessage?: string;
  errorMessage?: string;
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}

export function createMutationHandlers<TData = unknown, TError = Error>(
  options: ToastOptions = {}
) {
  const {
    successMessage = 'Operation completed successfully',
    errorMessage = 'An error occurred',
    showSuccessToast = true,
    showErrorToast = true,
  } = options;

  return {
    onSuccess: (_data: TData) => {
      if (showSuccessToast) {
        toast({
          variant: 'success',
          title: 'Success',
          description: successMessage,
        });
      }
    },
    onError: (error: TError) => {
      if (showErrorToast) {
        const message =
          error instanceof Error
            ? error.message
            : typeof error === 'object' && error !== null && 'message' in error
              ? String((error as { message: unknown }).message)
              : errorMessage;
        toast({
          variant: 'destructive',
          title: 'Error',
          description: message,
        });
      }
    },
  };
}

export function showSuccessToast(message: string, title = 'Success') {
  toast({
    variant: 'success',
    title,
    description: message,
  });
}

export function showErrorToast(message: string, title = 'Error') {
  toast({
    variant: 'destructive',
    title,
    description: message,
  });
}

export function showWarningToast(message: string, title = 'Warning') {
  toast({
    variant: 'warning',
    title,
    description: message,
  });
}

export function showInfoToast(message: string, title = 'Info') {
  toast({
    variant: 'default',
    title,
    description: message,
  });
}
